import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { selectUser } from '../../store/selectors/auth.selectors';

@Injectable({
  providedIn: 'root',
})
class PublicGuardService {
  constructor(
    private _store: Store,
    private _router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this._store.select(selectUser).pipe(
      take(1),
      map((user) => {
        // Always allow access to reset-password route, even if user is authenticated
        if (state.url.startsWith('/reset-password')) {
          return true;
        }
        // If user is authenticated and trying to access other public routes, redirect to dashboard
        if (user) {
          this._router.navigate(['/']);
          return false;
        }
        return true;
      })
    );
  }
}

export const PublicGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  return inject(PublicGuardService).canActivate(next, state);
};
